import { render, staticRenderFns } from "./GridRowBorders.vue?vue&type=template&id=935c0e36&lang=pug"
import script from "./GridRowBorders.vue?vue&type=script&lang=js"
export * from "./GridRowBorders.vue?vue&type=script&lang=js"
import style0 from "./GridRowBorders.vue?vue&type=style&index=0&id=935c0e36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports